import * as React from 'react';
import BackToTopButton from './BackToTopButton';

function PremiumSubscriptionSuccess() {
  return (
    <div>
      <div className="page-header">
        <h3 className="page-title">Welcome to Premium!</h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">Subscription Confirmed</li>
          </ol>
        </nav>
      </div>

      <div className="row">
        <div className="col-12 grid-margin">
          <div className="card">
            <div className="card-body">
              <div className="text-center mb-4">
                <h2 className="text-success">🎉 Thank you for subscribing to Premium! 🎉</h2>
                <p className="lead">Your premium features are now activated. Here's what you can do with your subscription:</p>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <h4 className="text-success mb-3">Premium Features</h4>
                  <ul className="plan-features">
                    <li>Save valuations for companies using your own assumptions</li>
                    <li>Discover when your favorite stocks are undervalued using your own saved assumptions</li>
                    <li>Add stocks you love to your favorites list</li>
                    <li>Track the performance and valuations of the stocks you love</li>
                    <li>Unlimited company look-ups</li>
                    <li>Create unlimited watchlists</li>
                    <li>Create unlimited stock screens</li>
                    <li>Discover new companies and investment opportunities with your pre-set screeners and assumptions</li>
                  </ul>
                </div>

                <div className="col-md-6">
                  <h4 className="text-success mb-3">AI Assistant Access</h4>
                  <ul className="plan-features">
                    <li><strong>Monthly AI Assistant Allowance:</strong></li>
                    <ul>
                      <li>100 questions/tasks to <strong>Lima</strong>, our AI Stock Market Research Analyst</li>
                      <li>100 earnings call questions to <strong>Saturday</strong>, our AI Stock Market Research Assistant</li>
                      <li>80 questions/tasks to <strong>June</strong>, our AI Stock Market Research Assistant for SEC filings</li>
                    </ul>
                    <li><strong>Autonomous AI Features:</strong></li>
                    <ul>
                      <li>40 autonomous AI generated insights per month</li>
                    </ul>
                  </ul>
                </div>
              </div>

              <div className="text-center mt-4">
                <a href="/dashboard" className="btn btn-success mr-2">Go to Dashboard</a>
                <a href="/" className="btn btn-outline-success">Get started!</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BackToTopButton />
    </div>
  );
}

export default PremiumSubscriptionSuccess;
